import React from 'react';
//#endregion
//#region IconsElementPickerImports
import addElement from '../../../assets/icons/ElementPicker/ic_addElement.svg';
import removeElement from '../../../assets/icons/ElementPicker/ic_removeElement.svg';
import triangle from '../../../assets/icons/ElementPicker/ic_triangle.svg';
import icCheckGreen from '../../../assets/icons/icCheckGreen.svg';
import addBlack from '../../../assets/icons/ic_addBlack.svg';
import addPicture from '../../../assets/icons/ic_addPicture.svg';
import addWhite from '../../../assets/icons/ic_addWhite.svg';
import icAddGreen from '../../../assets/icons/ic_add_green.svg';
import addPointage from '../../../assets/icons/ic_add_pointage.svg';
import affaire from '../../../assets/icons/ic_affaire.svg';
import affaireWhite from '../../../assets/icons/ic_affaire_white.svg';
import arrowLeftGreen from '../../../assets/icons/ic_arrowLeftGreen.svg';
import delivery from '../../../assets/icons/ic_delivery.svg';
import deliveryWhite from '../../../assets/icons/ic_delivery_white.svg';
//#endregion
//#region IconsArrowGreen
import arrowRightGreen from '../../../assets/icons/ic_arrowRightGreen.svg';
import icArrowRight from '../../../assets/icons/ic_arrowRightWhite.svg';
import icCalendar from '../../../assets/icons/ic_calendar.svg';
import carDisabled from '../../../assets/icons/ic_carDisabled.svg';
import carDisabledCircled from '../../../assets/icons/ic_carDisabledCircled.svg';
//#endregion
//#region IconsCarPointage
import carEnabled from '../../../assets/icons/ic_carEnabled.svg';
import carEnabledCircled from '../../../assets/icons/ic_carEnabledCircled.svg';
import car from '../../../assets/icons/ic_carWhite.svg';
import icCheckValid from '../../../assets/icons/ic_check_valid.svg';
import chevronDown from '../../../assets/icons/ic_chevron_down.svg';

import calendar_question from '../../../assets/icons/ic_calendar_question.svg';
import choix from '../../../assets/icons/ic_choix.svg';
import signature from '../../../assets/icons/ic_signature.svg';
import text from '../../../assets/icons/ic_text.svg';

import chevronUp from '../../../assets/icons/ic_chevron_up.svg';
import clipboard from '../../../assets/icons/ic_clipboard.svg';
import clock from '../../../assets/icons/ic_clockPointage.svg';
//#region IndividualIconsImports
import icCheckBoxBlue from '../../../assets/icons/ic_checkBox_blue.svg';
import icCheckBoxGreen from '../../../assets/icons/ic_checkBox_green.svg';
import icCheckBoxPurple from '../../../assets/icons/ic_checkBox_purple.svg';
import { default as close, default as icClose } from '../../../assets/icons/ic_close.svg';
import icCloseBlack from '../../../assets/icons/ic_close_black.svg';
import icCloseDialog from '../../../assets/icons/ic_close_dialog.svg';
import icCloseWhite from '../../../assets/icons/ic_close_white.svg';
import icCommentDisabled from '../../../assets/icons/ic_comment_disabled.svg';
import icCommentEnabled from '../../../assets/icons/ic_comment_enabled.svg';
import compagnons from '../../../assets/icons/ic_compagons.svg';
import compagnonsChecked from '../../../assets/icons/ic_compagons_checked.svg';
import icConduiteChariot from '../../../assets/icons/ic_conduite_chariot.svg';
import icConduiteGrue from '../../../assets/icons/ic_conduite_grue.svg';
import icConduiteNacelle from '../../../assets/icons/ic_conduite_nacelle.svg';
import icConduiteChariotBgWhite from '../../../assets/icons/ic_conduite_chariot_white.svg';
import icConduiteGrueBgWhite from '../../../assets/icons/ic_conduite_grue_white.svg';
import icConduiteNacelleBgWhite from '../../../assets/icons/ic_conduite_nacelle_white.svg';
import icDanger from '../../../assets/icons/ic_danger.svg';
import icDayCheckGreen from '../../../assets/icons/ic_day_check_green.svg';
import icDayCheckPurple from '../../../assets/icons/ic_day_check_purple.svg';
import icDayCheckWhite from '../../../assets/icons/ic_day_check_white.svg';
import icDayEMarkWhite from '../../../assets/icons/ic_day_emark_white.svg';
import icDelete from '../../../assets/icons/ic_delete.svg';
import icDeleteWhite from '../../../assets/icons/ic_delete_white.svg';
import downloadBlue from '../../../assets/icons/ic_downloadBlue.svg';
import downloadOrange from '../../../assets/icons/ic_downloadOrange.svg';
import icDrag from '../../../assets/icons/ic_drag.svg';
import icDropZone from '../../../assets/icons/ic_dropzone.svg';
import icCheckEmpty from '../../../assets/icons/ic_emptyCheck.svg';
import icCheckEmptyWhite from '../../../assets/icons/ic_emptyCheck_white.svg';
import emptyList from '../../../assets/icons/ic_emptyList.svg';
import engins from '../../../assets/icons/ic_engins.svg';
import enginsChecked from '../../../assets/icons/ic_engins_checked.svg';
import exportOrange from '../../../assets/icons/ic_exportOrange.svg';
import exportWhite from '../../../assets/icons/ic_exportWhite.svg';
import grab from '../../../assets/icons/ic_grab.svg';
import hashtag from '../../../assets/icons/ic_hashtag.svg';
import icKey from '../../../assets/icons/ic_key.svg';
import icMail from '../../../assets/icons/ic_mail.svg';
import planningRemove from '../../../assets/icons/ic_planning_remove.svg';

import materiels from '../../../assets/icons/ic_materiels.svg';
import materielsChecked from '../../../assets/icons/ic_materiels_checked.svg';
import openLink from '../../../assets/icons/ic_openLink.svg';
import pdf from '../../../assets/icons/ic_pdf.svg';
import icRemove from '../../../assets/icons/ic_remove.svg';
import save from '../../../assets/icons/ic_save.svg';
import saveWhite from '../../../assets/icons/ic_save_white.svg';
import search from '../../../assets/icons/ic_search.svg';
import selectArrowDown from '../../../assets/icons/ic_selectArrowDown.svg';
import selectArrowDownOrange from '../../../assets/icons/ic_selectArrowDownOrange.svg';
import selectArrowDownOrangeBold from '../../../assets/icons/ic_selectArrowDownOrangeBold.svg';
import selectArrowDownWhite from '../../../assets/icons/ic_selectArrowDownWhite.svg';
import send from '../../../assets/icons/ic_send.svg';
import vehicules from '../../../assets/icons/ic_vehicules.svg';
import vehiculesChecked from '../../../assets/icons/ic_vehicules_checked.svg';
import write from '../../../assets/icons/ic_write.svg';
//#endregion
//#region IconsPaginationImports
import iconPaginationEllipsis from '../../../assets/icons/PaginationIcons/ic_pagination_ellipsis.svg';
import iconPaginationNext from '../../../assets/icons/PaginationIcons/ic_pagination_next.svg';
import iconPaginationPrevious from '../../../assets/icons/PaginationIcons/ic_pagination_previous.svg';
//#endregion
// #region IconsRadioImports
import radioChecked from '../../../assets/icons/RadioIcons/ic_radioChecked.svg';
import radioUnchecked from '../../../assets/icons/RadioIcons/ic_radioUnchecked.svg';
//#endregion
import iconPublish from '../../../assets/icons/ic_publish.svg';
import iconCopyPlanning from '../../../assets/icons/ic_copy_planning.svg';
import iconRefresh from '../../../assets/icons/ic_refresh.svg';

export interface IconProps {
    wrappedIcon: JSX.Element;
}

const Icon = ({ wrappedIcon }: IconProps): React.ReactElement => {
    return wrappedIcon;
};

// #region IndividualIcons
export const IconCompagnons = Icon({
    wrappedIcon: <img src={compagnons} alt="icon compagnons" />,
});

export const IconMateriels = Icon({
    wrappedIcon: <img src={materiels} alt="icon materiels" />,
});

export const IconEngins = Icon({
    wrappedIcon: <img src={engins} alt="icon engins" />,
});

export const IconVehicules = Icon({
    wrappedIcon: <img src={vehicules} alt="icon vehicules" />,
});

export const IconCompagnonsChecked = Icon({
    wrappedIcon: <img src={compagnonsChecked} alt="icon compagnons" />,
});

export const IconMaterielsChecked = Icon({
    wrappedIcon: <img src={materielsChecked} alt="icon materiels" />,
});

export const IconEnginsChecked = Icon({
    wrappedIcon: <img src={enginsChecked} alt="icon engins" />,
});

export const IconVehiculesChecked = Icon({
    wrappedIcon: <img src={vehiculesChecked} alt="icon vehicules" />,
});

export const IconArrowDown = Icon({
    wrappedIcon: <img src={icClose} alt="icon-arrow-down" />,
});

export const IconText = Icon({
    wrappedIcon: <img src={text} alt="icon text" />,
});

export const IconChoix = Icon({
    wrappedIcon: <img src={choix} alt="icon choix" />,
});

export const IconCalendarQuestion = Icon({
    wrappedIcon: <img src={calendar_question} alt="icon calendar_question" />,
});

export const IconSignature = Icon({
    wrappedIcon: <img src={signature} alt="icon signature" />,
});

export const IconArrowRight = Icon({
    wrappedIcon: <img src={icArrowRight} alt="icon-arrow-right" />,
});

export const IconClipboard = Icon({ wrappedIcon: <img src={clipboard} alt="clipboard icon" /> });

export const IconSelect = Icon({
    wrappedIcon: <img src={selectArrowDown} alt="arrow down icon" />,
});

export const IconSelectOrange = Icon({
    wrappedIcon: <img src={selectArrowDownOrange} alt="arrow down icon" />,
});

export const IconSelectOrangeBold = Icon({
    wrappedIcon: <img src={selectArrowDownOrangeBold} alt="arrow down icon" />,
});

export const IconCheckGreen = Icon({
    wrappedIcon: <img src={icCheckGreen} alt="check green icon" />,
});

export const IconMail = Icon({
    wrappedIcon: <img src={icMail} alt="mail icon" />,
});

export const IconKey = Icon({
    wrappedIcon: <img src={icKey} alt="key icon" />,
});

export const IconSelectWhite = Icon({
    wrappedIcon: <img src={selectArrowDownWhite} alt="arrow down icon white" />,
});

export const IconCloseDialog = Icon({
    wrappedIcon: <img src={icCloseDialog} alt="close dialog icon" />,
});
export const IconClose = Icon({ wrappedIcon: <img src={close} alt="close icon" /> });
export const IconCloseWhite = Icon({
    wrappedIcon: <img src={icCloseWhite} alt="close icon white" />,
});
export const IconCloseBlack = Icon({
    wrappedIcon: <img src={icCloseBlack} alt="close icon black" />,
});

export const IconPlanningRemove = Icon({
    wrappedIcon: <img src={planningRemove} alt="close icon black" />,
});

export const IconSearch = Icon({ wrappedIcon: <img src={search} alt="search icon" /> });

export const IconAddPicture = Icon({
    wrappedIcon: <img src={addPicture} alt={'add pic icon'} />,
});

export const IconAddWhite = Icon({
    wrappedIcon: <img src={addWhite} alt={'add icon'} />,
});

export const IconAddBlack = Icon({
    wrappedIcon: <img src={addBlack} alt={'add icon'} />,
});

export const IconAddGreen = Icon({
    wrappedIcon: <img src={icAddGreen} alt={'add icon green'} />,
});

export const IconDropZone = Icon({
    wrappedIcon: <img src={icDropZone} alt={'icon dropzone'} />,
});

export const IconGrab = Icon({ wrappedIcon: <img src={grab} alt="grab icon" /> });

export const IconWrite = Icon({ wrappedIcon: <img src={write} alt="write icon" /> });

export const IconSave = Icon({ wrappedIcon: <img src={save} alt="save icon" /> });

export const IconSaveWhite = Icon({ wrappedIcon: <img src={saveWhite} alt="save icon" /> });

export const IconExportWhite = Icon({
    wrappedIcon: <img src={exportWhite} alt="export white icon" />,
});

export const IconExportOrange = Icon({
    wrappedIcon: <img src={exportOrange} alt="export orange icon" />,
});

export const IconDownloadOrange = Icon({
    wrappedIcon: <img src={downloadOrange} alt="download icon" />,
});

export const IconDownloadBlue = Icon({
    wrappedIcon: <img src={downloadBlue} alt="download icon" />,
});

export const IconEmptyList = Icon({
    wrappedIcon: <img src={emptyList} alt="empty icon" />,
});

export const IconDelete = Icon({
    wrappedIcon: <img src={icDelete} alt="icon-delete" />,
});

export const IconDeleteWhite = Icon({
    wrappedIcon: <img src={icDeleteWhite} alt="icon-delete-white" />,
});

export const IconDrag = Icon({
    wrappedIcon: <img src={icDrag} alt="icon-drag" />,
});

export const IconRemove = Icon({
    wrappedIcon: <img src={icRemove} alt="icon-remove" />,
});

export const IconAffaire = Icon({
    wrappedIcon: <img src={affaire} alt="affaire icon" />,
});

export const IconAffaireWhite = Icon({
    wrappedIcon: <img src={affaireWhite} alt="affaire icon" />,
});

export const IconDelivery = Icon({
    wrappedIcon: <img src={delivery} alt="delivery icon" />,
});

export const IconDeliveryWhite = Icon({
    wrappedIcon: <img src={deliveryWhite} alt="delivery icon" />,
});

export const IconAddPointage = Icon({
    wrappedIcon: <img src={addPointage} alt="add pointage icon" />,
});

export const IconOpenLink = Icon({
    wrappedIcon: <img src={openLink} alt="open link icon" />,
});

export const IconHashtag = Icon({
    wrappedIcon: <img src={hashtag} alt="hashtag icon" />,
});

export const IconClock = Icon({
    wrappedIcon: <img src={clock} alt="clock icon" />,
});

export const IconCar = Icon({
    wrappedIcon: <img src={car} alt="car icon" />,
});

export const IconPDF = Icon({
    wrappedIcon: <img src={pdf} alt="pdf icon" />,
});

export const IconSend = Icon({
    wrappedIcon: <img src={send} alt="send icon" />,
});

export const IconChevronDown = Icon({
    wrappedIcon: <img src={chevronDown} alt="chevron down icon" />,
});

export const IconChevronUp = Icon({
    wrappedIcon: <img src={chevronUp} alt="chevron up icon" />,
});

export const IconCalendar = Icon({
    wrappedIcon: <img src={icCalendar} alt="calendar icon" />,
});

export const IconDanger = Icon({
    wrappedIcon: <img src={icDanger} alt="danger icon" />,
});

export const IconConduiteChariot = Icon({
    wrappedIcon: <img src={icConduiteChariot} alt="conduite chariot icon" />,
});
export const IconConduiteGrue = Icon({
    wrappedIcon: <img src={icConduiteGrue} alt="conduite grue icon" />,
});
export const IconConduiteNacelle = Icon({
    wrappedIcon: <img src={icConduiteNacelle} alt="conduite nacelle icon" />,
});

export const IconConduiteChariotBgWhite = Icon({
    wrappedIcon: <img src={icConduiteChariotBgWhite} alt="conduite chariot icon" />,
});
export const IconConduiteGrueBgWhite = Icon({
    wrappedIcon: <img src={icConduiteGrueBgWhite} alt="conduite grue icon" />,
});
export const IconConduiteNacelleBgWhite = Icon({
    wrappedIcon: <img src={icConduiteNacelleBgWhite} alt="conduite nacelle icon" />,
});

export const IconDayCheckWhite = Icon({
    wrappedIcon: <img src={icDayCheckWhite} alt="icon check" />,
});
export const IconDayCheckGreen = Icon({
    wrappedIcon: <img src={icDayCheckGreen} alt="icon check" />,
});
export const IconDayCheckPurple = Icon({
    wrappedIcon: <img src={icDayCheckPurple} alt="icon check" />,
});
export const IconDayEMarkWhite = Icon({
    wrappedIcon: <img src={icDayEMarkWhite} alt="icon check" />,
});

// #endregion

// #region IconsRadio
const IconRadioChecked = Icon({ wrappedIcon: <img src={radioChecked} alt="radio checked icon" /> });
const IconRadioUnchecked = Icon({
    wrappedIcon: <img src={radioUnchecked} alt="radio unchecked icon" />,
});

export const IconsRadio = { IconRadioChecked, IconRadioUnchecked };

//#endregion

//#region  IconsPagination
const IconPaginationPrevious = Icon({
    wrappedIcon: <img src={iconPaginationPrevious} alt="pagination-previous-icon" />,
});
const IconPaginationEllipsis = Icon({
    wrappedIcon: <img src={iconPaginationEllipsis} alt="pagination-ellipsis-icon" />,
});
const IconPaginationNext = Icon({
    wrappedIcon: <img src={iconPaginationNext} alt="pagination-next-icon" />,
});

export const CustomPaginationIcons = {
    IconPaginationPrevious,
    IconPaginationEllipsis,
    IconPaginationNext,
};
//#endregion

//#region IconsElementPicker
const IconAddElement = Icon({ wrappedIcon: <img src={addElement} alt="add element icon" /> });
const IconRemoveElement = Icon({
    wrappedIcon: <img src={removeElement} alt="remove element icon" />,
});
const IconTriangle = Icon({ wrappedIcon: <img src={triangle} alt="triangle icon" /> });

export const IconsElementPicker = { IconAddElement, IconRemoveElement, IconTriangle };
//#endregion

//#region IconsArrowGreen
const IconArrowRightGreen = Icon({
    wrappedIcon: <img src={arrowRightGreen} alt="arrow right green" />,
});

const IconArrowLeftGreen = Icon({
    wrappedIcon: <img src={arrowLeftGreen} alt="arrow left green" />,
});

export const IconsArrowGreen = { IconArrowRightGreen, IconArrowLeftGreen };
//#endregion

//#region IconsCarPointage
const IconCarEnabled = Icon({
    wrappedIcon: <img src={carEnabled} alt="car enabled" />,
});

const IconCarDisabled = Icon({
    wrappedIcon: <img src={carDisabled} alt="car disabled" />,
});

const IconCarEnabledCircled = Icon({
    wrappedIcon: <img src={carEnabledCircled} alt="car enabled circled" />,
});

const IconCarDisabledCircled = Icon({
    wrappedIcon: <img src={carDisabledCircled} alt="car disabled circled" />,
});

export const IconsCarPointages = {
    IconCarEnabled,
    IconCarDisabled,
    IconCarEnabledCircled,
    IconCarDisabledCircled,
};
//#endregion

export const IconEmptyCheck = Icon({
    wrappedIcon: <img src={icCheckEmpty} alt="radio checked icon" />,
});
export const IconEmptyCheckWhite = Icon({
    wrappedIcon: <img src={icCheckEmptyWhite} alt="radio checked icon" />,
});
export const IconValidCheck = Icon({
    wrappedIcon: <img src={icCheckValid} alt="radio checked icon" />,
});
export const IconCheckBoxGreen = Icon({
    wrappedIcon: <img src={icCheckBoxGreen} alt="radio checked icon" />,
});
export const IconCheckBoxPurple = Icon({
    wrappedIcon: <img src={icCheckBoxPurple} alt="radio checked icon" />,
});
export const IconCheckBoxBlue = Icon({
    wrappedIcon: <img src={icCheckBoxBlue} alt="radio checked icon" />,
});
export const IconCommentDisabled = Icon({
    wrappedIcon: <img src={icCommentDisabled} alt="radio checked icon" />,
});
export const IconCommentEnabled = Icon({
    wrappedIcon: <img src={icCommentEnabled} alt="radio checked icon" />,
});
export const IconPublish = Icon({
    wrappedIcon: <img src={iconPublish} alt="publish icon" />,
});

export const IconCopyPlanning = Icon({
    wrappedIcon: <img src={iconCopyPlanning} alt="copy planning icon" />,
});

export const IconRefresh = Icon({
    wrappedIcon: <img src={iconRefresh} alt="refresh icon" />,
});

export default Icon;
